// extracted by mini-css-extract-plugin
export default {"commentBox":"gU5pB5","withPadding":"In9gk6"};